<template>
  <section class="content-block small-padding">
    <transition name="slide-fade-delay">
      <div
        v-if="active"
        class="block has-white-background"
      >

        <!-- SUCCESS-PAGE RESERVATION-PROCESS -->
        <div class="inner-block no-padding">
          <h1 class="title">
            {{ $t("bestaetigungView.label.loadReservation") }}
          </h1>
          <h2 class="subtitle">
            {{ $t("bestaetigungView.label.loadReservationHint") }}
          </h2>
          <a
            :href="$store.state.confirmation_pdf_url"
            class="button is-primary"
            target="_blank"
            download
          >{{ $t("general.button.loadAsPDF") }}</a>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import {liveURL} from '../../api-config';

export default {
  name: 'Start',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: false,
      res_link: ''
    }
  },
  mounted() {
    this.active = true

    this.fetch_GET_Reservation_Fn()
  },
  methods: {
    fetch_GET_Reservation_Fn() {
      let res_ID = this.$store.state.reservation_ID

      this.res_link = liveURL + '/api/ticket/slot/getBookingConfirmationPDF/' + res_ID + '/' + (this.$t('general.settings.currentLanguage'))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.marker {
  width: 100%;
  position: relative;
  display: block;
  text-align: center;

  .line {
    width: 100%;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }

  .subtitle {
    width: 100px;
    position: absolute;
    top: -0.55rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: block;
    color: rgba(180, 180, 180, 1);
    background-color: rgba(255, 255, 255, 1);
  }
}

// .inner-block {
//     &:last-of-type {
//         padding-top: 1.6rem;
//     }
// }

@media all and (min-width: 680px) and (max-width: 800px) {

}

@media (max-width: 680px) {
  .marker {
    .subtitle {
      top: -0.35rem;
    }
  }
}
</style>
